[
  {
    "title": "Featured",
    "href": "/docs/examples"
  },
  {
    "title": "Getting started",
    "pages": [
      {
        "href": "/docs/examples/hello_world",
        "title": "Hello, world"
      },
      {
        "href": "/docs/examples/webscraper",
        "title": "Simple web scraper"
      },
      {
        "href": "/docs/examples/basic_web",
        "title": "Serving Web Functions"
      }
    ]
  },
  {
    "title": "Large language models (LLMs)",
    "pages": [
      {
        "href": "/docs/examples/llm_inference",
        "title": "Deploy an OpenAI-compatible LLM service with vLLM"
      },
      {
        "href": "/docs/examples/ministral3_inference",
        "title": "Cut Ministral 3 cold start times by 10x with snapshots"
      },
      {
        "href": "/docs/examples/vllm_throughput",
        "title": "Maximize tokens per second in batch processing with vLLM"
      },
      {
        "href": "/docs/examples/sglang_low_latency",
        "title": "Serve an ultra-low-latency chatbot with SGLang"
      },
      {
        "href": "/docs/examples/nemotron_inference",
        "title": "Deploy Nemotron 3"
      },
      {
        "href": "/docs/examples/inkling_small",
        "title": "Serve Inkling-Small with SGLang"
      },
      {
        "href": "/docs/examples/deepseek_v4_flash",
        "title": "Serve DeepSeek-V4-Flash"
      },
      {
        "href": "/docs/examples/chat_with_pdf_vision",
        "title": "Run a multimodal RAG chatbot to answer questions about PDFs"
      },
      {
        "href": "/docs/examples/mcp_server_stateless",
        "title": "Deploy a stateless MCP with FastMCP"
      }
    ]
  },
  {
    "title": "Images, video, & 3D",
    "pages": [
      {
        "href": "/docs/examples/image_to_image",
        "title": "Edit images with Flux Kontext"
      },
      {
        "href": "/docs/examples/music-video-gen",
        "title": "Fine-tune Wan2.1 video models on your face"
      },
      {
        "href": "/docs/examples/flux",
        "title": "Run Flux fast with torch.compile"
      },
      {
        "href": "/docs/examples/image_to_video",
        "title": "Animate images with LTX-Video"
      },
      {
        "href": "/docs/examples/ltx",
        "title": "Generate video clips with LTX-Video"
      },
      {
        "href": "/docs/examples/text_to_image",
        "title": "Run Stable Diffusion with a CLI, API, and web UI"
      }
    ]
  },
  {
    "title": "Audio",
    "pages": [
      {
        "href": "/docs/examples/llm-voice-chat",
        "title": "Deploy a Moshi voice chatbot"
      },
      {
        "href": "/docs/examples/streaming_kyutai_stt",
        "title": "Stream transcripts at the speed of speech using Kyutai STT"
      },
      {
        "href": "/docs/examples/generate_music",
        "title": "Make music with ACE-Step"
      },
      {
        "href": "/docs/examples/chatterbox_tts",
        "title": "Generate speech with Chatterbox"
      },
      {
        "href": "/docs/examples/batched_whisper",
        "title": "Run high throughput batched transcription with Whisper"
      },
      {
        "href": "/docs/examples/fine_tune_asr",
        "title": "Fine-tune Whisper to recognize new words"
      }
    ]
  },
  {
    "title": "Real-time communication (WebRTC)",
    "pages": [
      {
        "href": "/docs/examples/webrtc_yolo",
        "title": "Serverless WebRTC"
      },
      {
        "href": "/docs/examples/fastrtc_flip_webcam",
        "title": "WebRTC quickstart with FastRTC"
      }
    ]
  },
  {
    "title": "Computational biology",
    "pages": [
      {
        "href": "/docs/examples/esmfold2_binder_design",
        "title": "Design protein binders with ESMFold2"
      },
      {
        "href": "/docs/examples/chai1",
        "title": "Fold proteins with Chai-1"
      },
      {
        "href": "/docs/examples/esm3",
        "title": "Build a protein-folding dashboard"
      },
      {
        "href": "/docs/examples/boltz_predict",
        "title": "Fold proteins with Boltz-2"
      }
    ]
  },
  {
    "title": "Modal Sandboxes",
    "pages": [
      {
        "href": "/docs/examples/cursor",
        "title": "Run Cursor Cloud Agents on Modal"
      },
      {
        "href": "/docs/examples/modal-vibe",
        "title": "Build a scalable AI coding platform"
      },
      {
        "href": "/docs/examples/claude-slack-gif-creator",
        "title": "Create GIFs from Slack using the Claude Agent SDK"
      },
      {
        "href": "/docs/examples/agent",
        "title": "Run a LangGraph agent's code in a secure GPU sandbox"
      },
      {
        "href": "/docs/examples/computer_use_vnc",
        "title": "Watch a computer-use agent work in real-time over VNC"
      },
      {
        "href": "/docs/examples/harbor_evals",
        "title": "Run massively parallel evals on Modal Sandboxes"
      },
      {
        "href": "/docs/examples/simple_code_interpreter",
        "title": "Build a stateful, sandboxed code interpreter"
      },
      {
        "href": "/docs/examples/safe_code_execution",
        "title": "Run Node.js, Ruby, and more in a Sandbox"
      },
      {
        "href": "/docs/examples/sandbox_pool",
        "title": "Speed up Sandbox starts with warm pools"
      },
      {
        "href": "/docs/examples/sandbox_secret_injection",
        "title": "Inject secrets into outbound requests"
      }
    ]
  },
  {
    "title": "Reinforcement Learning",
    "pages": [
      {
        "href": "/docs/examples/paint_flowers",
        "title": "Paint flowers with code"
      },
      {
        "href": "/docs/examples/swe_gym",
        "title": "Train coding agents"
      },
      {
        "href": "/docs/examples/miles_grpo",
        "title": "Make LLMs better at math"
      }
    ]
  },
  {
    "title": "Embeddings",
    "pages": [
      {
        "href": "/docs/examples/liquidai_embeddings_server",
        "title": "Serve Liquid AI embeddings with Modal Servers"
      },
      {
        "href": "/docs/examples/amazon_embeddings",
        "title": "Embed millions of documents with TEI"
      }
    ]
  },
  {
    "title": "Parallel processing and job scheduling",
    "pages": [
      {
        "href": "/docs/examples/hackernews_alerts",
        "title": "Deploy a Hacker News Slackbot"
      },
      {
        "href": "/docs/examples/doc_ocr_jobs",
        "title": "Run a Document OCR job queue"
      },
      {
        "href": "/docs/examples/doc_ocr_webapp",
        "title": "Serve a Document OCR web app"
      }
    ]
  },
  {
    "title": "Training models from scratch",
    "pages": [
      {
        "href": "/docs/examples/hp_sweep_gpt",
        "title": "Train an SLM with early-stopping grid search over hyperparameters"
      },
      {
        "href": "/docs/examples/long-training",
        "title": "Run long, resumable training jobs"
      }
    ]
  },
  {
    "title": "Hosting popular libraries",
    "pages": [
      {
        "href": "/docs/examples/finetune_yolo",
        "title": "YOLO: Fine-tune and serve computer vision models"
      },
      {
        "href": "/docs/examples/blender_video",
        "title": "Blender: Build a 3D render farm"
      },
      {
        "href": "/docs/examples/serve_streamlit",
        "title": "Streamlit: Run and deploy Streamlit apps"
      },
      {
        "href": "/docs/examples/cron_datasette",
        "title": "SQLite: Publish explorable data with Datasette"
      },
      {
        "href": "/docs/examples/algolia_indexer",
        "title": "Algolia: Build docsearch with a crawler"
      }
    ]
  },
  {
    "title": "Connecting to other APIs",
    "pages": [
      {
        "href": "/docs/examples/db_to_sheet",
        "title": "Google Sheets: Sync databases and APIs to a Google Sheet"
      },
      {
        "href": "/docs/examples/potus_speech_qanda",
        "title": "OpenAI: Run a RAG Q&A chatbot"
      },
      {
        "href": "/docs/examples/modal_tailscale",
        "title": "Tailscale: Add Modal Apps to your VPN"
      },
      {
        "href": "/docs/examples/pushgateway",
        "title": "Prometheus: Publish custom metrics with Pushgateway"
      }
    ]
  },
  {
    "title": "Managing data",
    "pages": [
      {
        "href": "/docs/examples/s3_bucket_mount",
        "title": "Mount S3 buckets in Modal Apps"
      },
      {
        "href": "/docs/examples/dbt_duckdb",
        "title": "Build your own data warehouse with DuckDB, dbt, and Modal"
      }
    ]
  },
  {
    "title": "Miscellaneous",
    "href": "/docs/examples/miscellaneous"
  }
]
